import { HttpClient, HttpEvent, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class ReportFileUploadService {
    constructor(private http: HttpClient) { }

    upload(formData: FormData): Observable<HttpEvent<any>> {
        const req = new HttpRequest('POST', `${environment.baseUrl}/Report/fileupload`, formData, {
            reportProgress: true,
            responseType: 'json',
        });

        return this.http.request(req);
    }

    getFiles(): Observable<any> {
        return this.http.get(`${environment.baseUrl}/files`);
    }

    multipleImageupload(formData: FormData): Observable<HttpEvent<any>> {

        const req = new HttpRequest('POST', `${environment.baseUrl}/Report/imageupload`, formData, {
            reportProgress: true,
            responseType: 'json',
        });

        return this.http.request(req);
    }
}
